var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.6 16.5",
    style: {
      enableBackground: "new 0 0 16.6 16.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4BA84F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.9,7.7C6,7.7,7.8,6,7.8,3.8C7.8,1.7,6,0,3.9,0S0.1,1.7,0.1,3.8C0.1,6,1.8,7.7,3.9,7.7z M1.4,3.8 c0-1.4,1.1-2.5,2.6-2.5c1.4,0,2.5,1.1,2.5,2.5S5.4,6.4,3.9,6.4c-0.6,0-1.3-0.2-1.7-0.6C1.7,5.3,1.4,4.6,1.4,3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.5,9.1L4.5,9.1C4.4,9,4.2,8.8,3.9,8.8c-0.2,0-0.5,0.1-0.5,0.4l-3.3,6.3C0,15.6,0,15.7,0,15.8 s0.1,0.3,0.1,0.4c0.1,0.1,0.4,0.3,0.6,0.3h6.5c0.2,0,0.5-0.1,0.5-0.3c0.1-0.2,0.1-0.5,0-0.7L4.5,9.1z M1.7,15.2l2.2-4.3l2.2,4.3 H1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.5,0.8H9.9c-0.5,0-1,0.5-1,1v13.5c0,0.5,0.5,1,1,1h5.6c0.5,0,1-0.5,1-1V1.8C16.6,1.3,16.1,0.8,15.5,0.8z  M15.3,2.1v13h-5.1v-13C10.2,2.1,15.3,2.1,15.3,2.1z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategory);
export default __webpack_public_path__ + "static/media/icon-category.55bef8842202bbf8b0bd3299c4bd45f6.svg";
export { ForwardRef as ReactComponent };